import { useContext } from "react";
import { IdPAuthContext, IdPAuthContextInterface } from "./IdPAuthContext";

/**
 * ```js
 * const {
 *   // IdP session state:
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // IdP methods:
 *   loginWithRedirect,
 *   getTokensSilently,
 *   logout,
 * } = useIdPAuth();
 * ```
 *
 * Use the `useIdPAuth` hook in your components to access the IdP session and methods.
 */
export const useIdPAuth = (context = IdPAuthContext): IdPAuthContextInterface =>
  useContext(context) as IdPAuthContextInterface;
